import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

export const useTrackChangesFilterStyles = makeStyles((theme: Theme) => ({
    filterContainer: {
        padding: '8px 12px',
        alignItems: 'center',
        width: pxToRem(325),
        height: pxToRem(30),
        top: pxToRem(33),
        borderRadius: pxToRem(4),
        borderWidth: pxToRem(1),
        justifyContent: 'space-between',
    },
    selectInput: {
        background: theme.palette.common.white,
        border: 'none',
        borderRadius: pxToRem(3.5),
        width: '100%',
        height: pxToRem(30),
        fontSize: pxToRem(12),
        '&:focus': {
            backgroundColor: theme.palette.common.white,
            outline: 'none',
        },
    },
    selectSelectOutlined: {
        padding: theme.spacing(1.5, 4, 1.25, 1),
    },
    filterDivider: {
        width: 325,
        borderBottom: '1px solid #0000001A',
        marginTop: 28,
    },
    endIcon: {
        marginRight: `${pxToRem(-20)} !important`,
    },
    filterOptionItem: {
        fontSize: pxToRem(12),
        fontFamily: 'Roboto',
        fontWeight: 400,
    },
}))
